import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { Box } from 'rebass/styled-components';

import LoadingOverlay from '@/components/LoadingOverlay';
import Text from '@/components/Text';
import { useQuerySubtaskDocs } from '@/hooks/queries/useQueryProject';

import DocumentItem from '../DocumentCenter/DocumentItem';

const ProjectDocList = ({ tid, sid }) => {
  const { query } = useRouter();
  const { data, status, isSuccess, isFetching } = useQuerySubtaskDocs(query.id, tid, sid);

  if (!isSuccess || data?.length)
    return (
      <>
        <Text mb={['20px', '20px', '20px']} mt={['32px', '32px', '32px']} variant="capsTitle">
          Anhänge
        </Text>
        <LoadingOverlay status={status} isFetching={isFetching} loadOnMount minHeight="60px">
          {data?.map?.((document) => (
            <Box my="5">
              <DocumentItem document={document} key={document.documentId} />
            </Box>
          )) ?? null}
        </LoadingOverlay>
      </>
    );

  return null;
};

ProjectDocList.propTypes = {
  tid: PropTypes.string.isRequired,
  sid: PropTypes.string.isRequired,
};

ProjectDocList.defaultProps = {};

export default ProjectDocList;
